import styled from 'styled-components';
import { COMMERCIAL, MUSIC_VIDEO } from './consts';

const widthBig = 350;
const widthSmall = 275;

const typeToColor = {
  [COMMERCIAL]: 'rgba(63, 94, 96, 0.7), rgba(0,65,108,0.6)',
  [MUSIC_VIDEO]: 'rgba(63, 94, 96, 0.7), rgba(0,108,10,0.6)',
};


export const StyledVideoCard = styled.div`
position: relative;
background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${(props) => props.thumbnail}) no-repeat bottom center / cover;
width: ${widthBig}px;
height: ${widthBig * 0.71}px;
border: ${(props) => (props.isActive ? '5px solid #ffa652' : '2px solid #52240b')};
border-radius: 5px;
transform: scale(1);
transition: transform .3s ease-in-out;
cursor: pointer;

  @media only screen and (max-width: 500px) {
    width: ${widthSmall}px;
    height: ${widthSmall * 0.71}px;
  }

&:hover {
transform: scale(1.1);
transition: transform .3s ease-in-out;
}
`;

export const StyledCardText = styled.h1`
color: white;
font-size: 1.3rem;
background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)) no-repeat bottom center / cover;
padding: 5px;
font-family: 'Lato', sans-serif;
`;

export const StyledCardType = styled.h1`
color: white;
font-size: 1rem;
background: linear-gradient(${({ type }) => typeToColor[type]}) no-repeat bottom center / cover;
padding: 5px;
font-family: 'Lato', sans-serif;
position: absolute;
bottom: 0;
left: 0;
border-radius: 3px;
letter-spacing: 1px;
`;
